import React from "react";
import TestMainScore from "./TestMainScore";
import BatsmenScoreCard from "./BatsmenScoreCard";
import SportAction from "../../Actions/SportAction";
import $ from "jquery";
let sk = null;
export default class TestMatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inningstab: false,
      inningsdata: [],
      inningsalldata: [],
      inningwisedata: [],
      res: null,
      close: false,
      queryparams: props.queryparams,
      matchstatus: ''
    };
    this.inningsTab = this.inningsTab.bind(this);
    this.fatchData = this.fatchData.bind(this);
  }

  componentDidMount() {
    this.fatchData();
  }

  fatchData() {
    let params = this.state.queryparams;
    // console.log(this.props);

    let req = SportAction.testcricket({
      match_id: params["match_id"],
      accessToken: params["token"],
      lang: params["lang"],
      islive: params['islive'] && params['islive'] == 1 ? "islive" : ""
    });
    req.then(res => {
      // console.log(">>>>res.data.data",res.data.data);
      let finalRes = res.data.data;
      let respall = finalRes;

      var resp = respall.innings;

      this.setState(
        {
          inningsalldata: respall,
          inningsdata: resp,
          res: finalRes,
          matchstatus: respall.status_str

        },

        () => {
          if (this.state.matchstatus == 'Live') {
            setTimeout(() => {
              this.fatchData();
            }, 10000);
          }
        }
      );
    });

    req.catch(error => {
      // handle error
      console.log(error.message);
    })

  }

  inningsTab(index) {
    let inningdata = this.state.inningsdata;
    inningdata = inningdata[index];
    this.setState({
      inningstab: true,
      inningwisedata: inningdata,
      innigindex: index,
      close: true
    });
    $(".div_" + index).toggle();
    if ($(".image_" + index).hasClass("down_tap_arrow")) {
      $(".image_" + index).removeClass("down_tap_arrow");
      $(".image_" + index).addClass("up_tap_arrow");
    } else {
      $(".image_" + index).addClass("down_tap_arrow");
      $(".image_" + index).removeClass("up_tap_arrow");
    }
  }

  render() {
    // console.log(this.state.inningsdata.length)
    // console.log(">>>>>>>>>>>>>>>>>>this.state.res",this.state.res);
    let res = this.state.res;
    // console.log(">>>>>>>>>>>>>>>>>>res",res);
    if (res) {
      return (
        <div>
          <link rel="stylesheet" href="/Assets/css/style.css" />
          <link rel="stylesheet" href="/Assets/css/mediasports.css" />

          <div className="">

            <div className="sports_widget_wrapp2">
              <div className="widget_top_section">
                <h6 className="widget_top_title">
                  {res && res.competition.title ? res.competition.title : ""}
                </h6>

                <div className="line_all_center">
                  <div className="horizline_center" />
                </div>
                <h4 className="matchBetwen">
                  {this.state.res ? this.state.res.short_title : ""}
                </h4>
              </div>
              <div className="widget_body_container">
                <TestMainScore inning={this.state.res} />
                {this.state.inningsdata && this.state.inningsdata.map((inning, index) => {
                  let display = { display: "none" };
                  try {

                    if (this.state.inningsdata.length == 1)
                      display = { display: "block" };

                  } catch (e) {
                    display = { display: "none" };
                  }


                  return (
                    <div>
                      <div
                        className="Innings_tab_section"
                        onClick={() => {
                          this.inningsTab(index);
                        }}
                      >
                        <h4 className="inningtap_title">{inning.name}</h4>
                        <img
                          src="/Assets/images/chevron_green_down.svg"
                          className={"updownarr down_tap_arrow image_" + index}
                        />
                      </div>

                      <div className={"div_" + index} style={display}>
                        <BatsmenScoreCard
                          res={this.state.res}
                          close={this.state.close}
                          activeInd={this.state.inningsdata.length - 1}
                          key={this.state.innigindex}
                          inningwisedata={this.state.inningsdata[index]}
                          index={index}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <div style={{
        "background": "#191919", "height": "100vh", "width": "100%"
      }}>
        <link rel="stylesheet" href="/Assets/css/style.css" />
        <link rel="stylesheet" href="/Assets/css/mediasports.css" />
      </div>
    }

  }
}
